import type {
	ThirdPartyEntityPage,
	AccessTokenStatus,
	ThirdPartyEntity,
	ThirdPartyEntityStats,
	ThirdPartyMembers,
	ThirdPartyFolderAndSubfolders,
	ThirdPartyEntityStatuses,
} from '../../../types';
import type { ThirdPartyClient, ThirdPartyFieldConfigData } from '../types';

export class NotSupportedClient implements ThirdPartyClient {
	private readonly ThirdParty?: string | null;

	constructor(thirdParty?: string) {
		this.ThirdParty = thirdParty;
	}

	getSpaces(): Promise<ThirdPartyEntity[]> {
		return Promise.reject(
			new Error(`ThirdParty: '${this.ThirdParty}' is not currently supported.`),
		);
	}

	getEntities(): Promise<ThirdPartyEntity[]> {
		return Promise.reject(
			new Error(`ThirdParty: '${this.ThirdParty}' is not currently supported.`),
		);
	}

	getEntityMembers(): Promise<ThirdPartyMembers[]> {
		return Promise.reject(
			new Error(`ThirdParty: '${this.ThirdParty}' is not currently supported.`),
		);
	}

	getEntityStats(): Promise<ThirdPartyEntityStats> {
		return Promise.reject(
			new Error(`ThirdParty: '${this.ThirdParty}' is not currently supported.`),
		);
	}

	getWorkspaces(): Promise<ThirdPartyEntity[]> {
		return Promise.reject(
			new Error(`ThirdParty: '${this.ThirdParty}' is not currently supported.`),
		);
	}

	startImport(): Promise<{ migrationId: string }> {
		return Promise.reject(
			new Error(`ThirdParty: '${this.ThirdParty}' is not currently supported.`),
		);
	}

	getFieldConfig(): Promise<ThirdPartyFieldConfigData> {
		return Promise.reject(
			new Error(`ThirdParty: '${this.ThirdParty}' is not currently supported.`),
		);
	}

	validateAccessToken(): Promise<{ status: AccessTokenStatus }> {
		return Promise.reject(
			new Error(`ThirdParty: '${this.ThirdParty}' is not currently supported.`),
		);
	}

	getSiteName(): Promise<string> {
		return Promise.reject(
			new Error(`ThirdParty: '${this.ThirdParty}' is not currently supported.`),
		);
	}

	postAccessToken(): Promise<void> {
		return Promise.reject(
			new Error(`ThirdParty: '${this.ThirdParty}' is not currently supported.`),
		);
	}

	getEntitiesPage(): Promise<ThirdPartyEntityPage> {
		return Promise.reject(
			new Error(`ThirdParty: '${this.ThirdParty}' is not currently supported.`),
		);
	}

	searchEntities(): Promise<ThirdPartyEntity[]> {
		return Promise.reject(
			new Error(`ThirdParty: '${this.ThirdParty}' is not currently supported.`),
		);
	}

	getFolders(): Promise<ThirdPartyFolderAndSubfolders> {
		return Promise.reject(new Error('getFolders method is not currently supported'));
	}

	getMultiEntityStats(): Promise<ThirdPartyEntityStats> {
		return Promise.reject(
			new Error(`ThirdParty: '${this.ThirdParty}' is not currently supported.`),
		);
	}

	getMultiEntityStatuses(): Promise<ThirdPartyEntityStatuses> {
		return Promise.reject(
			new Error(`ThirdParty: '${this.ThirdParty}' is not currently supported.`),
		);
	}
}
